import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { MediaEditorMode, MessageEditorComponentSettings, MessageEditorWithMediaTab } from "./types";

@Component
export default class MessageEditorPropsMixin extends Vue {
  /** Флаг, который позволяет прикреплять медиафайлы к сообщению */
  @Prop({ type: Boolean, default: true }) hasMedia!: MessageEditorComponentSettings['hasMedia']

  @Prop() disabled!: MessageEditorComponentSettings['disabled']

  /** При изменении данного параметра, меняется логика добавления медиа файлов */
  @Prop({ default: MediaEditorMode.TelegramBase }) editorMode!: MessageEditorComponentSettings['editorMode']

  /** Список с типами медиа файлов, которые будут недоступны для добавления */
  @Prop({ type: Array, default: () => [] }) blacklistMediaButtonTypes!: MessageEditorComponentSettings['blacklistMediaButtonTypes']

  @Prop({ type: String }) mediaButtonsMessage!: MessageEditorComponentSettings['mediaButtonsMessage']

  @Prop() targetToUpload!: MessageEditorComponentSettings['targetToUpload']

  @Prop({ type: Object }) topics?: MessageEditorComponentSettings['topics']

  /**
   * Поле предназначенное для передачи параметров полям, типа TagData.
   * Для Топиков обязательно передать поле topics со значением null или TagData
   */
  @Prop() options!: MessageEditorComponentSettings['options']

  /** Список для отображения тела редактора сообщения, по умолчанию доступны все (Ввод текста, ввод текста в формате кода и настройки сообщения) */
  @Prop({
    type: Array,
    default: (): Array<MessageEditorWithMediaTab> => [
      MessageEditorWithMediaTab.EditorTab,
      MessageEditorWithMediaTab.TextareaTab,
      MessageEditorWithMediaTab.SettingsTab
    ],
  })
  readonly availableTabs!: MessageEditorComponentSettings['availableTabs']

  @Prop() availableButtonsTypes?: MessageEditorComponentSettings['availableButtonsTypes']

  /** Максимальное кол-во символов в редакторе текста сообщения */
  @Prop({ type: Number, default: null }) readonly counterMax!: MessageEditorComponentSettings['counterMax']

  @Prop() placeholders?: MessageEditorComponentSettings['placeholders']

  /** Максимальное кол-во строк кнопок */
  @Prop({ type: Number, default: 8 }) declare readonly buttonsInRowMax: MessageEditorComponentSettings['buttonsInRowMax']

  /** Vue компонент, который будет показан с настройках клавиатуры в качестве подсказки */
  @Prop() buttonsHelpView!: MessageEditorComponentSettings['buttonsHelpView']

  @Prop() emptyKeyboardInfo!: MessageEditorComponentSettings['emptyKeyboardInfo']

  @Prop() settingsStructure!: MessageEditorComponentSettings['settingsStructure']

  @Prop() customMediaTypes!: MessageEditorComponentSettings['customMediaTypes']

  @Prop({ type: Number, default: 12, required: false }) maxMessagesCount: MessageEditorComponentSettings['maxMessagesCount']

  @Prop({ type: Boolean, required: false, default: false }) draggable!: MessageEditorComponentSettings['draggable']
}
